import React from "react";
import AthleteLayout from "./common/AthleteLayout";
import bgImg from "../images/wickets.png";

const NewFeatureTool = () => {
  return (
    <>
      {/* <AthleteLayout> */}
      <div className="h-full bg-white">
        <div className="w-full max-w-2xl mx-auto pl-5">
          <div className="flex flex-row overflow-hidden">
            <div className="w-[60%] pr-3 xs:pr-5 pt-20 pb-10">
              {/* title */}
              <div className="w-full text-center mb-10">
                <p className="text-black text-2xl xs:text-3xl font-bold border-b-4 border-darkYellow w-fit mx-auto pb-0.5">
                  Wickets
                </p>
              </div>
              {/*  input box */}
              <div className="flex items-stretch gap-4 xs:gap-5 mb-10">
                {/* M / F */}
                <div className="rounded-lg border border-black overflow-hidden shrink-0">
                  <div className="h-1/2 cursor-pointer flex justify-center items-center text-black text-xl !leading-none text-center rounded-lg p-3">
                    M
                  </div>
                  <div className="h-1/2 cursor-pointer flex justify-center items-center bg-black text-white text-xl !leading-none text-center rounded-md p-3">
                    F
                  </div>
                </div>

                {/* input */}
                <div className="rounded-lg border border-black flex flex-col gap-5">
                  <p className="bg-black text-white text-center text-lg font-medium !leading-none rounded-md py-2.5 px-3">
                    10m FLY
                  </p>
                  <div className="py-2 px-3">
                    <input
                      type="text"
                      name="wickets"
                      id="wickets"
                      value={1.1}
                      className="pb-1 w-full text-black text-2xl font-bold text-center border-b border-darkYellow"
                    />
                  </div>
                </div>
              </div>
              {/* Set Up */}
              <div className="mb-10 pl-4">
                <div className="border-b border-black pb-0.5 mb-3">
                  <strong className="text-black text-2xl font-bold capitalize">
                    Set Up
                  </strong>
                </div>
                <ul>
                  <li className="flex items-start gap-2">
                    <span className="size-3 bg-darkYellow aspect-square mt-1.5 pl-3 pr-1 -ml-5"></span>
                    <p className="text-black/70 text-sm xs:text-base font-medium leading-normal">
                      Wicket drills are used to reinforce upright sprint
                      mechanics and expose athletes to controllable max-velocity
                      rhythm, not conditioning.
                    </p>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="size-3 bg-darkYellow aspect-square mt-1.5 pl-3 pr-1 -ml-5"></span>
                    <p className="text-black/70 text-sm xs:text-base font-medium leading-normal">
                      Athletes should have a 20m sprint in prior to the first
                      wicket (W1) and an additional 10-15 m free sprint after
                      the last wicket. This should be from an up position and in
                      spikes.
                    </p>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="size-3 bg-darkYellow aspect-square mt-1.5 pl-3 pr-1 -ml-5"></span>
                    <p className="text-black/70 text-sm xs:text-base font-medium leading-normal">
                      Total sprint distance typically ranges from 40–70 m. Walk
                      back recovery between reps.
                    </p>
                  </li>
                </ul>
              </div>
              {/* Key Coaching Reminder */}
              <div className="pl-4">
                <div className="border-b border-black pb-0.5 mb-3">
                  <strong className="text-black text-2xl font-bold capitalize">
                    Key Coaching Reminder
                  </strong>
                </div>

                <div className="text-black text-sm xs:text-base font-medium space-y-0.5 mb-3">
                  <p>Velocity sets the spacing.</p>
                  <p>The setup determines the quality.</p>
                </div>
                <div className="text-black text-sm xs:text-base font-medium space-y-0.5 mb-3">
                  <p>Wickets work best when:</p>
                </div>

                <ul>
                  <li className="flex items-start gap-2">
                    <span className="size-3 bg-darkYellow aspect-square mt-1.5 pl-3 pr-1 -ml-5"></span>
                    <p className="text-black text-sm xs:text-base font-medium leading-normal">
                      The approach allows natural upright sprinting
                    </p>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="size-3 bg-darkYellow aspect-square mt-1.5 pl-3 pr-1 -ml-5"></span>
                    <p className="text-black text-sm xs:text-base font-medium leading-normal">
                      Spacing is velocity-based
                    </p>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="size-3 bg-darkYellow aspect-square mt-1.5 pl-3 pr-1 -ml-5"></span>
                    <p className="text-black text-sm xs:text-base font-medium leading-normal">
                      Total distance stays short enough to maintain quality
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex-1 relative pr-0 pt-28 bg-wickets">
              <div className="relative z-[2] flex flex-col numberGrid">
                <div className="relative flex numberBox h-20">
                  <div className="w-1/3 numberLeft -mt-2">
                    <p className="text-[#fcfbfb] text-[10px] xs:text-base font-medium opacity-50">
                      w10
                    </p>
                  </div>
                  <div className="w-1/3 numberCenter">
                    <div className="px-1 xs:px-2 block h-full">
                      <div className="border-y-4 border-darkYellow py-5 text-center flex justify-center items-center h-full">
                        <p className="text-white text-xs xs:text-xl font-medium">2.1m</p>
                      </div>
                    </div>
                  </div>
                  <div className="w-1/3"></div>
                </div>
                <div className="relative flex numberBox h-20">
                  <div className="w-1/3 numberLeft -mt-2">
                    <p className="text-[#fcfbfb] text-[10px] xs:text-base font-medium opacity-50">
                      w9
                    </p>
                  </div>
                  <div className="w-1/3 numberCenter">
                    <div className="px-1 xs:px-2 block h-full">
                      <div className="border-b-4 border-darkYellow py-5 text-center flex justify-center items-center h-full">
                        <p className="text-white text-xs xs:text-xl font-medium">2.1m</p>
                      </div>
                    </div>
                  </div>
                  <div className="w-1/3"></div>
                </div>
                <div className="relative flex numberBox h-20">
                  <div className="w-1/3 numberLeft -mt-2">
                    <p className="text-[#fcfbfb] text-[10px] xs:text-base font-medium opacity-50">
                      w8
                    </p>
                  </div>
                  <div className="w-1/3 numberCenter">
                    <div className="px-1 xs:px-2 block h-full">
                      <div className="border-b-4 border-darkYellow py-5 text-center flex justify-center items-center h-full">
                        <p className="text-white text-xs xs:text-xl font-medium">2.1m</p>
                      </div>
                    </div>
                  </div>
                  <div className="w-1/3"></div>
                </div>
                <div className="relative flex numberBox h-20">
                  <div className="w-1/3 numberLeft -mt-2">
                    <p className="text-[#fcfbfb] text-[10px] xs:text-base font-medium opacity-50">
                      w7
                    </p>
                  </div>
                  <div className="w-1/3 numberCenter">
                    <div className="px-1 xs:px-2 block h-full">
                      <div className="border-b-4 border-darkYellow py-5 text-center flex justify-center items-center h-full">
                        <p className="text-white text-xs xs:text-xl font-medium">2m</p>
                      </div>
                    </div>
                  </div>
                  <div className="w-1/3"></div>
                </div>
                <div className="relative flex numberBox h-20">
                  <div className="w-1/3 numberLeft -mt-2">
                    <p className="text-[#fcfbfb] text-[10px] xs:text-base font-medium opacity-50">
                      w6
                    </p>
                  </div>
                  <div className="w-1/3 numberCenter">
                    <div className="px-1 xs:px-2 block h-full">
                      <div className="border-b-4 border-darkYellow py-5 text-center flex justify-center items-center h-full">
                        <p className="text-white text-xs xs:text-xl font-medium">2m</p>
                      </div>
                    </div>
                  </div>
                  <div className="w-1/3"></div>
                </div>
                <div className="relative flex numberBox h-20">
                  <div className="w-1/3 numberLeft -mt-2">
                    <p className="text-[#fcfbfb] text-[10px] xs:text-base font-medium opacity-50">
                      w5
                    </p>
                  </div>
                  <div className="w-1/3 numberCenter">
                    <div className="px-1 xs:px-2 block h-full">
                      <div className="border-b-4 border-darkYellow py-5 text-center flex justify-center items-center h-full">
                        <p className="text-white text-xs xs:text-xl font-medium">2m</p>
                      </div>
                    </div>
                  </div>
                  <div className="w-1/3"></div>
                </div>
                <div className="relative flex numberBox h-20">
                  <div className="w-1/3 numberLeft -mt-2">
                    <p className="text-[#fcfbfb] text-[10px] xs:text-base font-medium opacity-50">
                      w4
                    </p>
                  </div>
                  <div className="w-1/3 numberCenter">
                    <div className="px-1 xs:px-2 block h-full">
                      <div className="border-b-4 border-darkYellow py-5 text-center flex justify-center items-center h-full">
                        <p className="text-white text-xs xs:text-xl font-medium">1.9m</p>
                      </div>
                    </div>
                  </div>
                  <div className="w-1/3"></div>
                </div>
                <div className="relative flex numberBox h-20">
                  <div className="w-1/3 numberLeft -mt-2">
                    <p className="text-[#fcfbfb] text-[10px] xs:text-base font-medium opacity-50">
                      w3
                    </p>
                  </div>
                  <div className="w-1/3 numberCenter">
                    <div className="px-1 xs:px-2 block h-full">
                      <div className="border-b-4 border-darkYellow py-5 text-center flex justify-center items-center h-full">
                        <p className="text-white text-xs xs:text-xl font-medium">1.9m</p>
                      </div>
                    </div>
                  </div>
                  <div className="w-1/3"></div>
                </div>
                <div className="relative flex numberBox h-20">
                  <div className="w-1/3 numberLeft -mt-2">
                    <p className="text-[#fcfbfb] text-[10px] xs:text-base font-medium opacity-50">
                      w2
                    </p>
                  </div>
                  <div className="w-1/3 numberCenter">
                    <div className="px-1 xs:px-2 block h-full">
                      <div className="border-b-4 border-darkYellow py-5 text-center flex justify-center items-center h-full">
                        <p className="text-white text-xs xs:text-xl font-medium">1.9m</p>
                      </div>
                    </div>
                  </div>
                  <div className="w-1/3"></div>
                </div>
                <div className="relative flex numberBox h-20">
                  <div className="w-1/3 numberLeft -mt-2">
                    <p className="text-[#fcfbfb] text-[10px] xs:text-base font-medium opacity-50">
                      w1
                    </p>
                  </div>
                  <div className="w-1/3 numberCenter">
                    <div className="px-1 xs:px-2 block h-full">
                      <div className="border-b-4 border-darkYellow py-5 text-center flex justify-center items-center h-full">
                        <p className="text-white text-xs xs:text-xl font-medium">1.9m</p>
                      </div>
                    </div>
                  </div>
                  <div className="w-1/3"></div>
                </div>
              </div>

              {/* <div className="absolute inset-0 z-0 bg-[url('./images/wickets.png')] bg-repeat"> */}
              {/* <img src={bgImg} alt="bgImg" className="w-full h-full object-center" /> */}
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
      {/* </AthleteLayout> */}
    </>
  );
};

export default NewFeatureTool;
